// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

const config = { basename: process.env.PUBLIC_URL };
const history = createBrowserHistory(config);

export default history;
